module.exports = __webpack_public_path__ + "img/landing-icon-2.0ea1cad2.png";